import React from 'react';

import { reverse } from 'named-urls';

import Record from 'ui/Record/Record';

import MainHeader from 'components/MainHeader';

import { PrimaryButton } from 'components/Button';

import routes from 'core/routes';

import { useNavBarHeight } from 'utils/hooks/navbar';

import { useStore } from 'utils/hooks/store';

import AuditTemplatesTable from './components/AuditTemplatesTable';

const AuditTemplates: React.FunctionComponent = (): React.ReactElement => {
  const navBarHeight = useNavBarHeight();
  const { routing } = useStore();

  return (
    <Record
      Header={
        <MainHeader
          title="Templates"
          breadcrumbs={[
            { label: 'Audits', link: routes.dashboard.audits.forms.toString() },
            { label: 'Templates', link: routes.dashboard.audits.templates.toString() },
          ]}
          action={
            <PrimaryButton
              // Routes to the builder in create mode, mirroring the legacy `templateId: 'new'` convention.
              onClick={() => routing.push(reverse(routes.dashboard.audits.templates.details, { templateId: 'new' }))}
            >
              New template
            </PrimaryButton>
          }
        />
      }
      Content={(onError) => <AuditTemplatesTable onError={onError} />}
      navBarHeight={navBarHeight}
    />
  );
};

export default AuditTemplates;
